import { GET_USER_INFO } from '@/src/common/gql/queries/user'
import { useLoggedInQuery } from '@/src/common/gql/MesaGql'
import {
  CardImagesSchema,
  useCardDesignParameterStore,
} from '@/src/services/Statsig/useCardDesignParameterStore'
import { ImageBackground, StyleSheet, View, type ViewStyle } from 'react-native'

export function CardFront({
  style: otherStyles,
  imageBackgroundStyle,
  frozen,
}: {
  style?: ViewStyle
  imageBackgroundStyle?: ViewStyle
  frozen?: boolean
}) {
  const cardDesignStore = useCardDesignParameterStore()
  const { data: userData } = useLoggedInQuery(GET_USER_INFO, {
    fetchPolicy: 'cache-first',
  })

  const cardDesigns = CardImagesSchema.parse(cardDesignStore.get('card_details', {}))
  const partnerName = userData?.getUserInfo.sourcePartnerName?.toLowerCase() ?? 'default'
  const remoteCardImageURL = cardDesigns[partnerName]?.image_url

  return (
    <View style={[styles.container, otherStyles]}>
      <ImageBackground
        style={[styles.cardImage, imageBackgroundStyle]}
        imageStyle={{ borderRadius: imageBackgroundStyle?.borderRadius }}
        source={
          remoteCardImageURL
            ? { uri: remoteCardImageURL }
            : require('@/src/assets/images/Mesa_Card.png')
        }
        blurRadius={frozen ? 8 : 0}
        resizeMode="cover"
        resizeMethod="scale"
      />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  cardImage: {
    alignItems: 'center',
    overflow: 'hidden',
  },
})
